import React from 'react';
import { Redirect } from 'react-router-dom';
import authRoles from 'app/auth/authRoles';

const SettingsConfig = {
  settings: {
    layout: {}
  },
  routes: [
    {
      // The Admin Console holds Automations and the general settings now, not just
      // the user list, so the route is gated rather than merely hidden from the nav.
      path: '/settings/users',
      auth: authRoles.adminConsole,
      component: React.lazy(() => import('./users/Users'))
    },
    {
      // Was reachable by any signed-in account, so anybody could open anybody's
      // profile — including their access level and their commission rows — by
      // knowing a user id.
      path: '/settings/user/:userId',
      auth: authRoles.manageUsers,
      component: React.lazy(() => import('./user/User'))
    },
    {
      path: '/settings/contacts',
      component: React.lazy(() => import('./contacts/Contacts'))
    },
    {
      path: '/settings/contact/:contactId',
      auth: authRoles.dataDirectoryEdit,
      component: React.lazy(() => import('./contact/Contact'))
    },
    // Legacy directory URLs, kept so bookmarks and cached navbar links keep working.
    {
      path: '/settings/agents',
      component: () => <Redirect to="/settings/contacts" />
    },
    {
      path: '/settings/agent/:contactId',
      component: ({ match }) => <Redirect to={`/settings/contact/${match.params.contactId}`} />
    },
    {
      path: '/userprofile',
      component: React.lazy(() => import('./userprofile/Userprofile'))
    },
    {
      path: '/settings/sales-target',
      component: () => <Redirect to="/dashboards/monthly-chart" />
    }
  ]
};

export default SettingsConfig;
